<template>
    <div class="content-search-label">
        <p>Ich suche...</p>
    </div>
    <search-list
            :placeholder="labelKeyword"
            :search-label="labelSuche"
            :isContentSearch="true"
            :isSimpleSearchField="isSimpleSearchField"/>    
</template>

<script lang="ts" setup>
import SearchList from '@/vue_components/product-overview/searchlist/search-list.vue';

    // const props: defineProps({});
    // const emit = defineEmits([]);

    const props = defineProps({
        isSimpleSearchField: {
            type: Boolean,
            required: false,
        }
    });
    // reactive Data
    // constant Data
    const labelKeyword = "";
    const labelSuche = "Suchen";

    // methods
</script>